import { Flex, Text } from '@chakra-ui/react';
import { Icons } from './Icons';
import { useTranslation } from 'react-i18next';

export function NoData({
  label,
  showIcon,
}: {
  label?: string;
  showIcon?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Flex
      boxSize="full"
      opacity={0.2}
      gap={2}
      {...(showIcon
        ? {
            alignItems: 'center',
            justifyContent: 'center',
          }
        : null)}
    >
      {showIcon && <Icons.CloudQuestion boxSize="16" />}
      <Text fontWeight="bold">{label ? label : t('general.noData')}</Text>
    </Flex>
  );
}
